import api from "../axiosConfig"

const resource = "/reservas"

function getDefaultParams(
  options = { page: undefined, pageSize: undefined, sort: undefined }
) {
  const populate = {
    "populate[responsavel]": "*",
    "populate[dias]": "*",
    "populate[sala][populate]": "bloco",
  }
  let sort = {}
  if (options.sort) {
    sort = {
      "sort[0]": `${options.sort.field}:${options.sort.order}`,
    }
  }
  let pagination = {}
  if (options.page && options.pageSize) {
    pagination = {
      "pagination[page]": `${options.page}`,
      "pagination[pageSize]": `${options.pageSize}`,
    }
  }
  return Object.assign(sort, populate, pagination)
}

export default {
  get(
    status,
    page,
    pageSize,
    sort = { field: "publishedAt", order: "asc" },
    filtros = {}
  ) {
    let params = getDefaultParams({ page, pageSize, sort })

    const conditions = []
    let filters = {}

    if (status !== "Historico") {
      conditions.push({ "[status][$eq]": status })
    }

    if (status === "Confirmado") {
      conditions.push({ "[data_termino][$gte]": new Date() })
    }

    if (filtros.userId) {
      conditions.push({ "[sala][responsavel][id][$eq]": filtros.userId })
    }

    if (filtros.titulo) {
      conditions.push({ "[titulo][$containsi]": filtros.titulo })
    }

    if (filtros.responsavel) {
      conditions.push({
        "[responsavel][username][$containsi]": filtros.responsavel,
      })
    }

    if (filtros.estado) {
      conditions.push({ "[status][$containsi]": filtros.estado })
    }

    if (filtros.dataInicio) {
      conditions.push({ "[data_inicio][$containsi]": filtros.dataInicio })
    }

    if (filtros.dataSolicitacao) {
      conditions.push({ "[publishedAt][$containsi]": filtros.dataSolicitacao })
    }

    if (conditions.length == 1) {
      const [key, value] = Object.entries(conditions[0])[0]
      filters[`filters${key}`] = value
    } else {
      for (const [i, condition] of conditions.entries()) {
        const [key, value] = Object.entries(condition)[0]
        filters[`filters[$and][${i}]${key}`] = value
      }
    }

    params = Object.assign(params, { ...filters })
    return api.get(`${resource}`, { params })
  },
  create(payload) {
    return api.post(`${resource}`, payload)
  },
  update(id, payload) {
    return api.put(`${resource}/${id}`, payload)
  },
  getOne(id) {
    return api.get(`${resource}/${id}`, {
      params: getDefaultParams(),
    })
  },
}
